import React, { useEffect, useState } from "react";
import { DotLoaderOverlay } from 'react-spinner-overlay';

import causalService from "../services/causal.service";

/** MUI */
import {
    Box,
    Button,
    Container,
    Typography
} from "@mui/material";
import MUIDataTable from 'mui-datatables';

const CausalJefeRRHH = () => {
    const [casusales, setCasusales] = useState([]);
    const [loading, setLoading] = useState(false);
    const refreshTime = 3600000;

    useEffect(() => {
        retreiveCausales();
        const comInterval = setInterval(retreiveCausales, refreshTime);
        //retreiveCausales();
        return () => clearInterval(comInterval);
    }, []);

    async function retreiveCausales() {
        setLoading(true);
        try {
            const currentURL = window.location.host;
            const protocol = window.location.protocol;
            const baseurl = protocol + "//" + currentURL;
            let causals = await causalService.getCausalJefeRRHH();
            console.log("Causales", causals);
            var csls = causals.data;
            csls.sort(function (a, b) {
                return b.id - a.id;
            });
            var arr_temp = [];
            for (var i in csls) {
                console.log(csls[i]);
                var persona = csls[i].persona;
                let temp = {
                    nombre: csls[i].perNombre1 + " " + csls[i].perApPaterno,
                    rut: csls[i].Rut,
                    link: `${baseurl}/finiquitojrrhh/${csls[i].id}`,
                    fecha_ingreso: csls[i].fecha_ingreso,
                    unidad_negocio: csls[i].ctoDescripcion,
                }
                arr_temp.push(temp);

            }
            setCasusales(arr_temp);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const columns = [
        { name: "rut", label: "Rut" },
        { name: "nombre", label: "Nombre" },
        { name: "unidad_negocio", label: "Unidad de Negocio" },
        { name: "fecha_ingreso", label: "Fecha Desvinculación" },
        {
            name: "link", label: "Link", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Button href={value} variant='outlined' target="_blank">VER FINIQUITO</Button>
                )
            }
        },
    ];

    return (
        <Container>
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Typography variant="h3">
                CAUSALES
            </Typography>
            <Box
                margin={3}
                alignItems="center"
                justifyContent="center"
                display="flex"
            >
                <MUIDataTable
                    columns={columns}
                    data={casusales}
                />
            </Box>
        </Container>
    )

}

export default CausalJefeRRHH;